module.exports = __webpack_public_path__ + "651993318c86bda601e5485c0a188d1e.svg";